<template>
  <milestone-wrapper :subscription-period-id="subscriptionPeriodId" :data="data" :meta="meta">
    <template slot="content-completed">
      <div v-if="content" class="col-xs-12">
        <email-batch-display :email="content.emails[0]" />

        <GridTable :columns="columns" :rows="content.items" class="q-mt-md">
          <template #row="{row}">
            <GridTableCell class="text-center">{{ row.name }}</GridTableCell>
            <GridTableCell class="text-right">{{ formatPrice(row.price) }}</GridTableCell>
            <GridTableCell class="text-center">{{ row.currency }}</GridTableCell>
            <GridTableCell class="text-center">{{ getPeriod(row) }}</GridTableCell>
          </template>
        </GridTable>
      </div>
    </template>
  </milestone-wrapper>
</template>

<script>
import MilestoneMixin from '@/mixins/milestone.mixin'
// Components
import MilestoneWrapper from '@/components/milestones/MilestoneWrapper'
import EmailBatchDisplay from '@/components/lm-blocks/EmailBatchDisplay'
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  name: 'MilestonePlaceOrders',
  components: {
    MilestoneWrapper,
    EmailBatchDisplay,
    GridTable,
    GridTableCell
  },

  mixins: [MilestoneMixin],

  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    subscriptionPeriodId: {
      type: Number,
      required: true
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Subscriptions included', width: '150px', align: 'center' },
        { label: 'Price', width: '1fr', align: 'right' },
        { label: 'Currency', width: '1fr', align: 'center' },
        { label: 'Period', width: '1fr', align: 'center' }
      ]
    }
  }
}
</script>
